import { useEffect, useRef, useState } from 'react';
import type { Message } from '../api/types';

interface Props {
  disabled: boolean;
  /** Сообщение, на которое отвечаем. */
  replyTo: Message | null;
  replyAuthor: string;
  onCancelReply: () => void;
  onSend: (body: string) => void;
  onTyping: () => void;
}

export function Composer({ disabled, replyTo, replyAuthor, onCancelReply, onSend, onTyping }: Props) {
  const [text, setText] = useState('');
  const areaRef = useRef<HTMLTextAreaElement>(null);

  // Нажали «ответить» — курсор должен оказаться в поле ввода сразу,
  // иначе приходится тянуться к нему мышью
  useEffect(() => {
    if (replyTo) areaRef.current?.focus();
  }, [replyTo]);

  function submit() {
    const body = text.trim();
    if (!body) return;
    onSend(body);
    setText('');
    if (areaRef.current) areaRef.current.style.height = 'auto';
    areaRef.current?.focus();
  }

  function onKeyDown(event: React.KeyboardEvent<HTMLTextAreaElement>) {
    // Enter отправляет, Shift+Enter переводит строку — привычка из всех мессенджеров
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      submit();
    }
    // Escape отменяет ответ — привычнее, чем искать крестик
    if (event.key === 'Escape' && replyTo) {
      onCancelReply();
    }
  }

  function onChange(event: React.ChangeEvent<HTMLTextAreaElement>) {
    setText(event.target.value);
    onTyping();
    const element = event.target;
    element.style.height = 'auto';
    element.style.height = Math.min(element.scrollHeight, 128) + 'px';
  }

  return (
    <div className="composer-wrap">
      {replyTo && (
        <div className="reply-banner">
          <div className="reply-banner-text">
            <span className="quote-author">{replyAuthor}</span>
            {replyTo.deleted ? 'сообщение удалено' : replyTo.body}
          </div>
          <button className="ghost" onClick={onCancelReply} title="Отменить ответ (Esc)">✕</button>
        </div>
      )}
      <div className="composer">
        <textarea
          ref={areaRef}
          value={text}
          onChange={onChange}
          onKeyDown={onKeyDown}
          placeholder={disabled ? 'Нет соединения…' : replyTo ? 'Ответ…' : 'Сообщение'}
          rows={1}
        />
        <button onClick={submit} disabled={!text.trim()}>
          Отправить
        </button>
      </div>
    </div>
  );
}
